import { render, staticRenderFns } from "./kitchenOrder.vue?vue&type=template&id=cee8a846&"
import script from "./kitchenOrder.vue?vue&type=script&lang=js&"
export * from "./kitchenOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports